import React, { useEffect, useState } from "react";

function InquiryPopup() {
  const [show, setShow] = useState(false);
  const [fromdata, setdfromdata] = useState({
    username: "",
    email: "",
    mobileno: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handlechange = (e) => {
    setdfromdata({ ...fromdata, [e.target.name]: e.target.value });
  };

  const handlesubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      alert("from submitted successfully");
      setdfromdata({ username: "", email: "", mobileno: "", message: "" });
    }, 5000);

    try {
      const res = await fetch("http://localhost:5000/send", {
        method: "Post",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(fromdata),
      });
      const data = await res.json();
      if (data.success) {
        setdfromdata({ username: "", email: "", mobileno: "", message: "" });
      } else {
        alert("failed message");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const logintimer = setTimeout(() => {
      setShow(true);
    }, 3000);
    return () => clearTimeout(logintimer);
  }, []);

  if (!show) return null;

  return (
    <div className="popup-overlay ">
      <div className="popup-box">
        {/* Close button */}
        <button className="close-btn" onClick={() => setShow(false)}>
          ✖
        </button>

        <h2 className="popup-title">Inquiry Form</h2>

        <form className="popup-form" onSubmit={handlesubmit}>
          <div className="mb-3 ms-4">
            {/* <label for="name" className="form-label">
              UserName
            </label> */}
            <input
              type="text"
              name="username"
              placeholder="Name"
              className="form-control"
              id="name"
              aria-describedby="emailHelp"
              onChange={handlechange}
              value={fromdata.username}
              required
            />
          </div>

          <div className="mb-3 ms-4">
            {/* <label for="exampleInputEmail1" className="form-label">
              Email address
            </label> */}
            <input
              type="email"
              name="email"
              placeholder="Email address"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              onChange={handlechange}
              value={fromdata.email}
              required
            />
          </div>
          <div className="mb-3 ms-4">
            {/* <label for="tel" className="form-label">
              Mobile Number
            </label> */}
            <input
              type="tel"
              name="mobileno"
              placeholder="Mobile Number"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              onChange={handlechange}
              value={fromdata.mobileno}
              required
            />
          </div>
          <div className="mb-3 ms-4">
            {/* <label for="messageTextarea" class="form-label">
              Your Message
            </label> */}
          
            <textarea
              className="form-control"
              name="message"
              id="messageTextarea"
              rows={3}
              placeholder="Enter your message"
              onChange={handlechange}
              value={fromdata.message}
            ></textarea>
          </div>

          {/* <button type="submit" className="submit-btn" disabled={!fromValidation}>
            Submit
          </button> */}
          <button type="submit" className="submit-btn rs-btn has-theme-orange has-icon has-bg has-skew" disabled={loading}>
            {loading ? "Loading..." : "Submit"}
            <i className="fa-solid fa-arrow-right arrow-right"></i>
          </button>



        </form>
      </div>
    </div>
  );
}

export default InquiryPopup;
